import { productColors } from '@givebutter/util';
import styled, { StyledProps, css } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: revert;
    align-items: center;
    & p {
        &:first-child {
            width: 75px;
        }
    }
`;

const getStyles = ({ theme, percent }: StyledProps<{ percent: number }>) => {
    return css`
        border-radius: ${theme.radius.default};
        background: ${productColors.gray[200]};
        &:after {
            content: '';
            height: 100%;
            background: ${productColors.success[500]};
            width: ${percent}%;
            min-width: 4px;
            position: absolute;
            top: 0;
            left: 0;
            border-radius: ${percent < 100 ? '5px 0 0 5px' : '5px'};
        }
    `;
};

export const Percentage = styled.div<{ percent: number }>`
    width: 132px;
    height: 8px;
    overflow: hidden;
    position: relative;
    margin: 0 12px;
    border-radius: 5px;
    ${getStyles};
`;
